// --------------------------------------------------------
// ENCAMINHAMENTO - EncaminhamentoField
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import { Divider } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react'
import CareLineDropdown from '../../../../../../../components/dropdown/CareLineDropdown';
import { H3 } from '../../../../../../../components/UI/generalLayout/Layout.styled'
import { removeFieldFromList } from '../../../../../../../helpers/CareLineHelperFunctions';
import AddButtonField from '../AddButtonField'
import { MediumInput } from '../DetailsAttendanceRecord.styled';
import { ReactComponent as Trash } from '../../../../../../../assets/imgs/trashBin.svg';
import { addValueToObject } from '../../../../../../../helpers/HelperFunctions';
import { AppointmentService } from '../../../../../../../core/http/service/AppointmentService';

// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// ENCAMINHAMENTO INTERFACE
// --------------------------------------------------------

interface IEncaminhamentoField {
    encaminhamentos: any[];
    isViewState: boolean;
    setEncaminhamentos: (value: any) => void;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const EncaminhamentoField = ({ encaminhamentos, setEncaminhamentos, isViewState }: IEncaminhamentoField) => {
    // --------------------------------------------------------
    // ENCAMINHAMENTO PRIVATE DECLARATIONS
    // --------------------------------------------------------
    const [especialidades, setEspecialidades] = useState<any[]>([])


    const getEspecialidadeData = useCallback(async () => {
        const especialidades: any[] = [];
        const service: AppointmentService = new AppointmentService();
        const result: any = await service.getEspecialidades();

        result.data.data.forEach((d: any)=>{
            especialidades.push(d)
        })

        setEspecialidades(especialidades)

    }, [])

    useEffect(()=>{
        getEspecialidadeData();
    }, [])
    // --------------------------------------------------------

    // --------------------------------------------------------
    // REACT RETURN FUNCTION
    // --------------------------------------------------------
    return (
        <>
            {encaminhamentos.map((enc: any, index: number) => {
                return <div>
                    <div>
                        <H3>Especialidade:</H3>
                        <CareLineDropdown
                            value={enc.especialidade}
                            onChange={(value: any) => { addValueToObject({ especialidade: value }, index, setEncaminhamentos) }}
                            items={especialidades}
                            containerStyle={{ width: 250 }}
                            disabled={isViewState}
                            placeholder="Buscar especialista"
                        />
                    </div>
                    <div>
                        <H3>Resumo do atendimento:</H3>
                        <MediumInput
                            value={enc.resumo}
                            disabled={isViewState}
                            placeholder='Digite o resumo do atendimento'
                            onChange={(event: any) => {
                                addValueToObject({ resumo: event.target.value }, index, setEncaminhamentos)
                            }}
                        />
                    </div>
                    <div>
                        <H3>Exames complementares:</H3>
                        <MediumInput
                            value={enc.examesComplementares}
                            disabled={isViewState}
                            placeholder="Digite sobre exames complementares"
                            onChange={(event: any) => {
                                addValueToObject({ examesComplementares: event.target.value }, index, setEncaminhamentos)
                            }}
                        />
                    </div>
                    <div style={{ marginBottom: 20 }}>
                        <H3>Hipóteses/Motivo para referenciar:</H3>
                        <MediumInput
                            value={enc.hipoteses}
                            disabled={isViewState}
                            placeholder="Digite sobre hipóteses e motivos para referenciar"
                            onChange={(event: any) => {
                                addValueToObject({ hipoteses: event.target.value }, index, setEncaminhamentos)
                            }}
                        />
                    </div>
                    {index !== 0 && !isViewState && (<div style={{ textAlign: "center", marginBottom: 8 }}>
                        <Trash onClick={() => {
                            setEncaminhamentos(removeFieldFromList(encaminhamentos, index))
                        }} style={{ cursor: 'pointer' }} />
                    </div>)}
                    <Divider />

                </div>
            })}
            {!isViewState && (<div>
                <AddButtonField
                    buttonText="Adicionar outro encaminhamento"
                    onClickFunction={() => {
                        setEncaminhamentos((prev: any) => {
                            const list = [...prev];
                            list.push({ especialidade: '', resumo: '', examesComplementares: '', hipoteses: '' })
                            return list;
                        })
                    }} />
            </div>)}
        </>
    )
    // --------------------------------------------------------
}

export default EncaminhamentoField